import Cookies from 'js-cookie'
import mfe88 from '@/utils/mfe88'

const TokenKey = (mfe88.env === 'prod' ? '' : mfe88.env + '-') + 'mfe88-token'
const ClientTokenKey = (mfe88.env === 'prod' ? '' : mfe88.env + '-') + 'mfe88-clientToken'
const LoginIdKey = (mfe88.env === 'prod' ? '' : mfe88.env + '-') + 'mfe88-loginId'
const LoginLastTimeKey = (mfe88.env === 'prod' ? '' : mfe88.env + '-') + 'mfe88-loginLastTime'
const domain = mfe88.env === 'local' ? 'localhost' : mfe88.domain
export function getToken() {
  return Cookies.get(TokenKey, { domain: domain })
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { domain: domain })
}

export function removeToken() {
  return Cookies.remove(TokenKey, { domain: domain })
}

export function getClientToken() {
  return Cookies.get(ClientTokenKey, { domain: domain })
}

export function setClientToken(token) {
  return Cookies.set(ClientTokenKey, token, { domain: domain })
}

export function removeClientToken() {
  return Cookies.remove(ClientTokenKey, { domain: domain })
}

export function getLoginId() {
  return Cookies.get(LoginIdKey, { domain: domain })
}

export function setLoginId(loginId) {
  return Cookies.set(LoginIdKey, loginId, { domain: domain })
}

export function removeLoginId() {
  return Cookies.remove(LoginIdKey, { domain: domain })
}
export function getLoginLastTime() {
  return Cookies.get(LoginLastTimeKey, { domain: domain })
}

export function setLoginLastTime(loginLastTime) {
  return Cookies.set(LoginLastTimeKey, loginLastTime, { domain: domain })
}

export function removeLoginLastTime() {
  return Cookies.remove(LoginLastTimeKey, { domain: domain })
}
